export default __webpack_public_path__ + "static/media/remoteStart.bbe6c8ab.mp4";